// extracted by css-extract-rspack-plugin
export default {"root":"History_root__s87z+"};